import React, { useEffect } from 'react';
import { useLegalDocumentT } from '../hooks/useLegalDocumentT.ts';
import { TermsDocumentContent } from '../components/legal/LegalDocumentContents.tsx';
import './css/TermsPage.css';

const LAST_UPDATED = '18.04.2026';

export default function TermsPage() {
  const { t, legalLang } = useLegalDocumentT();

  useEffect(() => {
    const previous = document.documentElement.lang;
    document.documentElement.lang = legalLang;
    return () => {
      document.documentElement.lang = previous;
    };
  }, [legalLang]);

  return (
    <div className="legal-page terms-page">
      <div className="legal-page-container">
        <h1 className="legal-page-title">{t('termsOfService.title')}</h1>
        <p className="legal-page-updated">{t('termsOfService.lastUpdated')}: {LAST_UPDATED}</p>
        <TermsDocumentContent t={t} />
      </div>
    </div>
  );
}
